var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isLetter } from "pages/utils/isLetter";
// export type OverviewItem = ArrayElement<OverviewItemWithOptionalChannel>;
export var toBoxCoverDetails = function (_a) {
    var image = _a.boxCoverImage, keys = __rest(_a, ["boxCoverImage"]);
    return (__assign(__assign({}, keys), { image: image }));
};
export var toContentItems = function (items) {
    return items.map(function (item, index) { return ({
        type: "content",
        position: index + 1,
        item: item,
    }); });
};
export var toContentItemsWithDividers = function (items) {
    var letterDict = items.reduce(function (acc, cur, index) {
        var firstLetter = cur.title.substring(0, 1).toUpperCase();
        var letter = isLetter(firstLetter) ? firstLetter : "#";
        if (acc[letter] === undefined) {
            acc[letter] = [{ type: "content", position: index + 1, item: cur }];
        }
        else {
            acc[letter] = __spreadArray(__spreadArray([], acc[letter], true), [
                { type: "content", position: index + 1, item: cur },
            ], false);
        }
        return acc;
    }, {});
    return Object.keys(letterDict).flatMap(function (letter) { return __spreadArray([
        { type: "divider", letter: letter }
    ], letterDict[letter], true); });
};
